import React from "react";
import Chart from "../../Chart";
import ExampleScatterChart from "../../../../components/Chart/ExampleScatterChart";

class ScatterChartExampleApplet extends Chart {

    render() {
        return <ExampleScatterChart applet={this}
                          attributes={this.state.Attributes}
                          xAxis={this.state.xAxis}
                          yAxis={this.state.yAxis}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "ScatterChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        xAxis: [
            { width: 50 }
        ],
        yAxis: [
            { width: 50 }
        ],
        zAxis: undefined,
        Series: [
            {
                type: "scatter",
                data: [],
                id: "pvId",
                label: "pv",
            },
            {
                type: "scatter",
                id: "uvId",
                data: [],
                label: 'uv'
            }
        ]
    }
}

export default ScatterChartExampleApplet;
